import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { WhatYouGet } from '../components/WhatYouGet';
import { PricingCTA } from '../components/PricingCTA';
export function SalesPage() {
  return <main className="min-h-screen bg-[#05080f] text-white selection:bg-blue-500/30 selection:text-blue-200" data-id="element-180">
      <Hero data-id="element-181" />
      <ProblemSection data-id="element-182" />
      <SolutionSection data-id="element-183" />
      <WhatYouGet data-id="element-184" />
      <PricingCTA data-id="element-185" />

      {/* Simple Footer */}
      <footer className="py-8 bg-[#020305] border-t border-white/5 text-center text-gray-600 text-sm" data-id="element-186">
        <div className="container mx-auto px-4" data-id="element-187">
          <p data-id="element-188">
            © {new Date().getFullYear()} Explosive Baseball Power System. All
            rights reserved.
          </p>
        </div>
      </footer>
    </main>;
}